import { setContext } from '@apollo/client/link/context';
import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  from,
} from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { OnTokenEvent } from '../modules/auth/auth-events';
import { createUploadLink } from 'apollo-upload-client';
import { BACKEND_ENDPOINT } from './constants';

export const httpLink = createHttpLink({
  uri: `${BACKEND_ENDPOINT}/graphql`,
});

export const clientUploadLink = createUploadLink({
  uri: `${BACKEND_ENDPOINT}/graphql`,
});

export const errorLink = onError((error) => {
  if (error.graphQLErrors) {
    // eslint-disable-next-line no-param-reassign
    error.graphQLErrors.map((options) => {
      if (options.message === 'Token expired') {
        return { ...options, message: 'Your session has expired' };
      }

      return options;
    });
  }

  if (error.response) {
    // eslint-disable-next-line no-param-reassign
    error.response.errors?.map((options: { message: string }) => {
      if (options.message === 'Token expired') {
        return { ...options, message: 'Your session has expired' };
      }

      return options;
    });
  }
});

export const authLink = setContext((_, { headers }) => {
  // get the authentication token from event storage if it exists
  const event = OnTokenEvent.get();
  if (event?.token) {
    return {
      headers: {
        ...headers,
        authorization: event && event.token ? `Bearer ${event.token}` : '',
      },
    };
  }
  return {
    headers: {
      ...headers,
    },
  };
});

export const authLinkUpload = setContext((_, { headers }) => {
  // get the authentication token from event storage if it exists
  const event = OnTokenEvent.get();
  if (event?.token) {
    return {
      headers: {
        ...headers,
        authorization: event && event.token ? `Bearer ${event.token}` : '',
        'Apollo-Require-Preflight': 'true',
      },
    };
  }
  return {
    headers: {
      ...headers,
    },
  };
});

const link = from([authLink, errorLink, httpLink]);

const uploadLink = from([authLinkUpload, errorLink, clientUploadLink]);

/**
 * Import client directly in the actions
 * it's not necessary to add to the event store.
 *
 * If the client is required in a component use the apollo hooks o HOC.
 */
export const client = new ApolloClient({
  link,
  cache: new InMemoryCache(),
});

export const clientUpload = new ApolloClient({
  link: uploadLink,
  cache: new InMemoryCache(),
});
